import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';

export function stringValue(value: string): StringValue {
  const msg = new StringValue();
  msg.setValue(value);
  return msg;
}
